<div *ngIf="section">
  <h4 id="{{section.id}}"> {{getSectionTitle()}}</h4>
  <div>
    <span>{{preferenceMessages.tab_1_label_12_part1 | translate }}</span>
    <span class="mandatory"> * </span>
    <span>{{preferenceMessages.tab_1_label_12_part2 | translate }}</span>
  </div>
  <div>
    <p class="messageInfo">
      {{parcoursUtilisateur(section)}}
    </p>
    <p *ngIf="rgpdWarning">{{rgpdMessage}}</p>
    <!--afficher les fields-->
    <div *ngFor="let field of section.fields; let i = index">
      <app-form-input [prefixId]="prefixId+'_0'" [field]="field" [parentForm]="formGroup"
        [repeatablePath]="repeatablePath" [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
        [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
        [noticeValue]="noticeValue" [groupOrSectionId]="section.id" (newField)="newField($event)"
        [index]="section.index" (deleteField)="deleteField($event)"></app-form-input>
    </div>
    <div *ngFor="let group of section.groups; let i = index">
      <app-accordion [elementId]="group.id" [prefixId]="prefixId" [isDeletable]="group.deletable"
        [elementLabel]="group._label" [isRepeatable]="group._repeatable" [infoBulle]="group.infoBulle"
        [groupType]="getGroupType(group.id)"
        (addSomething)="newGroup(group)" (deleteSomething)="deleteGroup(group)">
        <app-group *ngIf="!group?.hidden" [prefixId]="prefixId" [formGroup]="formGroup" [group]="group"
          [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
          (newGroup)="newGroup($event)" (deleteGroup)="deleteGroup($event)" [repeatablePath]="repeatablePath"
          [parentsChild]="section.groups" [getRepeatablePathWithIndexForGroup]="getRepeatablePathWithIndexForGroup"
          [noticeValue]="noticeValue" [indexGrp]="i" [indexSection]="section.index" [linkForRouter]="linkForRouter">
        </app-group>
      </app-accordion>
    </div>
    <div *ngIf="!isDuplicableElement()">
      <div *ngFor="let subSection of section.subsections; let i = index">
        <app-accordion [elementId]="subSection.id" [prefixId]=" prefixId" [hidden]="haveToHide(i)" [isDeletable]="subSection.deletable"
          [elementLabel]="subSection._label" [isRepeatable]="subSection._repeatable" [infoBulle]="subSection.infoBulle"
          [groupType]="getGroupType(subSection.id)"
          (addSomething)="newSubSection(subSection)" (deleteSomething)="deleteSubSection(subSection)">
          <app-sub-section *ngIf="!subSection?.hidden" [indexPage]="indexPage"
            [indexSection]="section.index" [prefixId]="prefixId.includes('_')?prefixId+'_'+i: prefixId+'_0_'+i"
            [formGroup]="formGroup" [subSection]="subSection" (newSubSection)="newSubSection($event)"
            (deleteSubSection)="deleteSubSection($event)" [repeatablePath]="repeatablePath"
            [parentsChild]="section.subsections" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
            [getRepeatablePathWithIndexForSubSection]="getRepeatablePathWithIndexForSubSection"
            [noticeValue]="noticeValue" [indexGrp]="i" [linkForRouter]="linkForRouter"></app-sub-section>
        </app-accordion>
      </div>
    </div>
    <div *ngIf="isDuplicableElement()">
      <div *ngFor="let subSection of getCounterArray(); let i = index">
        <app-duplicable-element [actualIndex]="i" [displayedElementIndex]="displayedElementIndex"
          [type]="section.subsections[0]._idScheme" [hidden]="haveToHide(i)"
          [duplicableElement]=section.subsections[0] [isDeletable]="isDuplicableElementDeletable()"
          [prefixId]="prefixId" (addSomething)="newDuplicableElement(section.subsections[0])"
          (deleteSomething)="deleteDuplicableElement(section.subsections[0], i)"
          (loadDuplicableElement)="loadDuplicableElement($event)">
          <app-sub-section *ngIf="displaySubSection(i)" [indexPage]="indexPage"
            [indexSection]="section.index" [prefixId]="prefixId.includes('_')?prefixId+'_'+i: prefixId+'_0_'+i"
            [formGroup]="formGroup" [subSection]="subSectionDuplicable" (newSubSection)="newSubSection($event)"
            (deleteSubSection)="deleteSubSection($event)" [repeatablePath]="repeatablePath"
            [parentsChild]="section.subsections" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
            [getRepeatablePathWithIndexForSubSection]="getRepeatablePathWithIndexForSubSection"
            [noticeValue]="noticeValue" [linkForRouter]="linkForRouter" [subSectionId]="section.subsections[0].id"
            [indexGrp]="((indexGrp != ''||isInteger(indexGrp))? indexGrp+'_'+getIncr(section.subsections[0].id): '')">
          </app-sub-section>
        </app-duplicable-element>
      </div>
    </div>
  </div>
</div>
